module.exports = __webpack_public_path__ + "img/inc-awards.759b52f6.svg";